import { render, staticRenderFns } from "./tags-page-opened.vue?vue&type=template&id=3be8228f&scoped=true"
import script from "./tags-page-opened.vue?vue&type=script&lang=js"
export * from "./tags-page-opened.vue?vue&type=script&lang=js"
import style0 from "./tags-page-opened.vue?vue&type=style&index=0&id=3be8228f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8228f",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/components/tags-page-opened.vue
// module id = null
// module chunks = 